import ParticipantsPanel from './ParticipantsPanel';

export default ParticipantsPanel;
